const isWxEnv = typeof window !== 'undefined' && !!window.wx

const wx = isWxEnv ? window.wx : {}

const noop = () => {}

wx.config = wx.config || noop
wx.ready = wx.ready || noop
wx.error = wx.error || noop
wx.updateTimelineShareData = wx.updateTimelineShareData || noop
wx.updateAppMessageShareData = wx.updateAppMessageShareData || noop
wx.onMenuShareTimeline = wx.onMenuShareTimeline || noop
wx.onMenuShareAppMessage = wx.onMenuShareAppMessage || noop
wx.scanQRCode = wx.scanQRCode || noop
wx.previewImage = wx.previewImage || noop
wx.miniProgram = wx.miniProgram || { navigateTo: noop }
wx.env = wx.env || { USER_DATA_PATH: '' }
wx.saveImageToPhotosAlbum = wx.saveImageToPhotosAlbum || noop
wx.getFileSystemManager = wx.getFileSystemManager || function () { return {} }
wx.showToast = wx.showToast || noop

/**
 * 加载配置
 * @param params
 * @returns {Promise<any>}
 */
wx.configAsync = (params = { debug: false, appId: '', timestamp: '', nonceStr: '', signature: '', jsApiList: [] }) => {
  return new Promise((resolve, reject) => {
    if (!isWxEnv) {
      reject(new Error('非微信环境'))
      return
    }
    wx.config(params)
    wx.ready(resolve)
    wx.error(function (res) {
      reject(new Error(res.errMsg))
    })
  })
}

/**
 * 自定义"分享到朋友圈"及"分享到QQ空间"按钮的分享内容
 * @param params
 * @returns {Promise<any>}
 */
wx.updateTimelineShareDataAsync = (params = {}) => {
  return new Promise((resolve, reject) => {
    if (!isWxEnv) {
      reject(new Error('非微信环境'))
      return
    }
    params.fail = res => {
      reject(res)
    }
    wx.updateTimelineShareData(params, (res) => {
      resolve(res)
    })
  })
}

/**
 * 自定义"分享给朋友"及"分享到QQ"按钮的分享内容
 * @param params
 * @returns {Promise<any>}
 */
wx.updateAppMessageShareDataAsync = (params = {}) => {
  return new Promise((resolve, reject) => {
    if (!isWxEnv) {
      reject(new Error('非微信环境'))
      return
    }
    params.fail = res => {
      reject(res)
    }
    wx.updateAppMessageShareData(params, (res) => {
      resolve(res)
    })
  })
}
wx.onMenuShareTimelineAsync = (params = {}) => {
  return new Promise((resolve, reject) => {
    if (!isWxEnv) {
      reject(new Error('非微信环境'))
      return
    }
    params.fail = res => {
      reject(res)
    }
    wx.onMenuShareTimeline(params, (res) => {
      resolve(res)
    })
  })
}
wx.onMenuShareAppMessageAsync = (params = {}) => {
  return new Promise((resolve, reject) => {
    if (!isWxEnv) {
      reject(new Error('非微信环境'))
      return
    }
    params.fail = res => {
      reject(res)
    }
    wx.onMenuShareAppMessage(params, (res) => {
      resolve(res)
    })
  })
}

/**
 * 调用扫一扫
 * @param params
 * @returns {Promise<any>}
 */
wx.scanQRCodeAsync = (params = { needResult: 1, scanType: ['qrCode', 'barCode'] }) => {
  return new Promise((resolve, reject) => {
    if (!isWxEnv) {
      reject(new Error('非微信环境'))
      return
    }
    wx.scanQRCode({
      needResult: params.needResult,
      scanType: params.scanType,
      success (res) {
        resolve(res)
      },
      fail (res) {
        reject(res)
      }
    })
  })
}
wx.downloadFile = (params = { url: '' }) => {
  return new Promise((resolve, reject) => {
    if (!isWxEnv) {
      reject(new Error('非微信环境'))
      return
    }
    params.fail = res => {
      reject(res)
    }
    wx.previewImage(params, (res) => {
      resolve(res)
    })
  })
}

export default wx
